enum SnippetLanguage {
    HTML = 'html',
    JS = 'js',
    JSON = 'json',
}

export { SnippetLanguage };
